export default [
  {
    path: '/required-documents',
    name: 'required-documents',
    component: () => import('@/views/required-documents/RequiredDocuments.vue'),
  },
]
